module.exports = __webpack_public_path__ + "static/media/swadlocations.86264184.jpg";